import React from 'react';
import Loadable from 'react-loadable';
import LoadableLoading from '../../components/LoadableLoading';
import { getApplicationAvailableColumns, getDoneResponses } from './api';

export const path = '/application/list';

const PageApplicationList: React.FC = (props) => {
  const LoadableMap = Loadable.Map({
    loader: {
      page: () => import(`./page`),
      i18n: () => import(`./ru.json`),
      columns: getApplicationAvailableColumns,
      doneResponses: getDoneResponses,
    },
    loading: LoadableLoading,
    render(loaded, loadedProps: {}) {
      const Page: any = loaded.page.default;

      return <Page {...loadedProps} {...loaded} />;
    },
  });

  return <LoadableMap {...props} />;
};

export default PageApplicationList;
